import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import DropDownSelect from '../../../../../../src/components/DropDownSelect/index';
import DropDownTileSelect from '../../../../../../src/components/DropDownTileSelect/index';
import Slider from 'rc-slider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { AssignmentFilterTypes } from '../../../utils/constants';
import { useGetSchoolDistrictInfoMutation } from '../../../../../features/authentication/dashboardHeaderApiSlice';
import { useGetAllCourseListMutation, useGetClassesMutation } from '../../../../../features/authentication/authApiSlice';
import { useUpdateGrowthReportValuesMutation } from '../../../../../features/authentication/persistApiSlice';
import { useGetClassManagementStudentsMutation } from '../../../../../features/authentication/classesApiSlice';
import { useGetTeacherAssignmentsMutation } from '../../../../../features/authentication/assignmentApislice';
import CustomToast from '../../../../../components/Toast';
import AssignmentTypes from '../../../../../enums/assignmentTypes';
import SkeletonGrid from '../../../../../components/SkeletonLoader/SkeletonGrid';
import { useSelector } from 'react-redux';
import { selectCurrentUserData } from '../../../../../features/authentication/authSlice';
import { useGetGrowthReportMutation } from '../../../../../features/authentication/reportApiSlice';
import { faSquarePlus, faSquareMinus, faCircleQuestion } from '@fortawesome/pro-solid-svg-icons';

const ReportFilter = ({
  dateTimeBasedUniqueKey,
  isLoadingReportData, 
  setIsLoadingReportData,
  persistData,
  setPersistData,
  setGrowthReport,
  setDisplayText,
  displayText,
  setDistrictName,
  districtName,
  setLocationName,
  locationName,
  setSelectedClassName,
  selectedClassName,
  setSelectedStudentName,
  selectedStudentName,
  setSelectedCourseName,
  selectedCourseName,
  setSelectedPreTestName,
  selectedPreTestName,
  setSelectedMidTestName,
  selectedMidTestName,
  setSelectedPostTestName,
  selectedPostTestName
}) => {
  let takeSize = 30;
  const user = useSelector(selectCurrentUserData);

  const [isLoading, setIsLoading] = useState(true);
  const [isReportCriteriaOpen, setIsReportCriteriaOpen] = useState(true);
  const [preTestList, setPreTestList] = useState([]);
  const [midTestList, setMidTestList] = useState([]);
  const [postTestList, setPostTestList] = useState([]);
  const [classList, setClassList] = useState([]);
  const [courseList, setCourseList] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [skip, setSkip] = useState(0);
  const [preAssignmentType, setPreAssignmentType] = useState(null);
  const [midAssignmentType, setMidAssignmentType] = useState(null);
  const [postAssignmentType, setPostAssignmentType] = useState(null);
  const [assignmentListLoading, setAssignmentListLoading] = useState(false);
  const [searchString, setSearchString] = useState('');
  const [selectedList, setSelectedDropDown] = useState('');

  const [getSchoolInfo] = useGetSchoolDistrictInfoMutation();
  const [getAllClasses] = useGetClassesMutation();
  const [getAllCourses] = useGetAllCourseListMutation();
  const [updateGrowthReportValues] = useUpdateGrowthReportValuesMutation();
  const [getAllStudents] = useGetClassManagementStudentsMutation();
  const [getAllAssignments] = useGetTeacherAssignmentsMutation();
  const [getGrowthReport] = useGetGrowthReportMutation();

  useEffect(() => {
    getSchoolDistrictInfoAsync();
    getAllClassesAsync();
    getAllCoursesAsync();
    getAllStudentsAsync(persistData.classID, persistData.studentID);
    getAllAssignmentsAsync(skip, takeSize, true, persistData.classID, persistData.studentID, persistData.courseID);
  }, []);

  const getSchoolDistrictInfoAsync = async() => {
    const response = await getSchoolInfo();
    setDistrictName(response.data.districtName);
    setLocationName(response.data.schoolName);
  };

  async function loadClasses()
  {
    var classes = await getAllClasses().unwrap();
    localStorage.setItem('classes', JSON.stringify(classes));

    if(classes.length > 0)
    {
      let updatedClassList = [
        {
          name: 'All Classes',
          id: -1,
          description: '',
          coTeacherClass: false
        },
        ...classes.map((item) => ({
          name: item.coTeacherClass ? `${item.className} (${item.teacherName})` : item.className,
          id: item.classID,
          description: item.className,
          coTeacherClass : item.coTeacherClass
        }))
      ];
      setClassList(updatedClassList);
      let selectedClassName = updatedClassList?.find(x=>x.id == persistData.classID)?.name;
      setSelectedClassName(selectedClassName ? selectedClassName : updatedClassList[0].name);
    }
  }

  const getAllClassesAsync = async() => {
    let classes = localStorage.getItem('classes');
    if (classes) {
      classes = JSON.parse(classes);
      let updatedClassList = [
        {
          name: 'All Classes',
          id: -1,
          description: '',
          coTeacherClass: false
        },
        ...classes.map((item) => ({
          name: item.coTeacherClass ? `${item.className} (${item.teacherName})` : item.className,
          id: item.classID,
          description: item.className,
          coTeacherClass : item.coTeacherClass
        }))
      ];
      setClassList(updatedClassList);
      let selectedClassName = updatedClassList?.find(x=>x.id == persistData.classID)?.name;
      setSelectedClassName(selectedClassName ? selectedClassName : updatedClassList[0].name);
    }else
      loadClasses();
  };

  async function loadCourses()
  {
    var courses = await getAllCourses().unwrap();
    localStorage.setItem('courses', JSON.stringify(courses));

    if(courses.length > 0)
    {
      const obj = {
        id: -1,
        name: 'All Courses'
      };
      let updatedCourseList = [obj, ...courses];
      setCourseList(updatedCourseList);
      let selectedCourseName = updatedCourseList?.find(x=>x.id == persistData.courseID)?.name;
      setSelectedCourseName(selectedCourseName ? selectedCourseName : obj.name);
    }
  }

  const getAllCoursesAsync = async() => {
    let courses = localStorage.getItem('courses');
    if (courses) {
      courses = JSON.parse(courses);
      const obj = {
        id: -1,
        name: 'All Courses'
      };
      let updatedCourseList = [obj, ...courses];
      setCourseList(updatedCourseList);
      let selectedCourseName = updatedCourseList?.find(x=>x.id == persistData.courseID)?.name;
      setSelectedCourseName(selectedCourseName ? selectedCourseName : obj.name);
    }else
      loadCourses();
  };

  const getAllStudentsAsync = async(classId, studentId) => {
    try {
      const options = {
        id: classId,
        includeDeleted: false
      };
      let response = await getAllStudents(options);
      if (response.error) {
        CustomToast(response.error.data.error, 'error');
      }
      else {
        let obj = {
          id: -1,
          name: 'All Students'
        };
        let updatedStudentsList = [
          obj,
          ...response.data.map(s => ({ id: s.studentId, name: `${s.fName} ${s.lName}` }))
        ];
        setStudentList(updatedStudentsList);
        let selectedStudentName = updatedStudentsList?.find(x=>x.id == studentId)?.name;
        setSelectedStudentName(selectedStudentName ? selectedStudentName : obj.name);
      }
    } catch (error) {
      console.log(error);
    }
    
    if(isLoading)
      setIsLoading(false);
  };

  const handleGenerateReport = async() => {
    setIsLoadingReportData(true);
    try {
      await updateGrowthReportValues(persistData);
      var options = {
        SchoolId : persistData.schoolID,
        TeacherId : persistData.teacherID,
        ClassId : persistData.classID,
        StudentId : persistData.studentID,
        PreTestId : persistData.preTestID,
        MidTestId : persistData.midTestID,
        PostTestId : persistData.postTestID
      };  
      var response = await getGrowthReport(options);
      if (response.error) {
        CustomToast(response.error.data.error, 'error');
      }
      else {
        setGrowthReport(response.data);
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoadingReportData(false);
  };

  const getAllAssignmentsAsync = async(skip, take, hasMore, classId, studentId, courseId, dropDownId = '', isResetAssignmentList = false) => {
    if (hasMore) {
      setAssignmentListLoading(true);
      try {
        let assignmentType = getAssignmentType(dropDownId);
        let persistPreTestId = isResetAssignmentList ? -1 : persistData.preTestID;
        let persistMidTestId = isResetAssignmentList ? -1 : persistData.midTestID;
        let persistPostTestId = isResetAssignmentList ? -1 : persistData.postTestID;

        const options = {
          skip: skip,
          take: take,
          filters : {
            classId: classId,
            courseId: courseId,
            studentId: studentId,
            searchString: searchString,
            assignmentType: assignmentType,
            preTestAssignmentId : persistPreTestId,
            midTestAssignmentId : persistMidTestId,
            postTestAssignmentId : persistPostTestId
          }
        };
        let response = await getAllAssignments(options);
        if (response.error) {
          CustomToast(response.error.data.error, 'error');
        }
        else {
          if(skip + take < response.data.total){
            setHasMore(true);
          }
          else{
            setHasMore(false);
          }

          if(response.data.data.length > 0)
          {
            let updatedAssignmentList = response.data.data.map(item => ({
              ...item,
              name: item.name + 
                (item.type === AssignmentTypes.PublicAssignment ? ' (PUBLIC ASSIGNMENT)' : 
                  item.type === AssignmentTypes.Benchmark ? ' (BENCHMARK)' : ''),
              type: (item.type === AssignmentTypes.PublicAssignment || item.type === AssignmentTypes.Benchmark ? 
                AssignmentTypes.Assignment : item.type)
            }));
            
            let updatedPreTestList = [];
            let updatedMidTestList = [];
            let updatedPostTestList = [];

            if(skip == 0)
            {
              switch(dropDownId)
              {
              case 'preTestList':
                updatedPreTestList = [{ id: -1, name: 'Select Pre Test' }, ...updatedAssignmentList]; 
                break;
              case 'midTestList':
                updatedMidTestList = [{ id: -1, name: 'Select Mid Test' }, ...updatedAssignmentList];
                break;
              case 'postTestList':
                updatedPostTestList = [{ id: -1, name: 'Select Post Test' }, ...updatedAssignmentList];
                break;
              default:
              {
                updatedPreTestList = [{ id: -1, name: 'Select Pre Test' }, ...updatedAssignmentList];
                updatedMidTestList = [{ id: -1, name: 'Select Mid Test' }, ...updatedAssignmentList];
                updatedPostTestList = [{ id: -1, name: 'Select Post Test' }, ...updatedAssignmentList];
              }
              }
            }
            else {
              switch(dropDownId)
              {
              case 'preTestList':
                updatedPreTestList = [...preTestList, ...updatedAssignmentList];
                break;
              case 'midTestList':
                updatedMidTestList = [...midTestList, ...updatedAssignmentList];
                break;
              case 'postTestList':
                updatedPostTestList = [...postTestList, ...updatedAssignmentList];
                break;
              default:
              {
                updatedPreTestList = [...preTestList, ...updatedAssignmentList];
                updatedMidTestList = [...midTestList, ...updatedAssignmentList];
                updatedPostTestList = [...postTestList, ...updatedAssignmentList];
              }
              }
            }
            
            switch(dropDownId)
            {
            case 'preTestList':
              setPreTestList(updatedPreTestList);
              setSelectedPreTestName(updatedPreTestList?.find(x=>x.id == persistPreTestId)?.name); 
              break;
            case 'midTestList':
              setMidTestList(updatedMidTestList);
              setSelectedMidTestName(updatedMidTestList?.find(x=>x.id == persistMidTestId)?.name);
              break;
            case 'postTestList':
              setPostTestList(updatedPostTestList);
              setSelectedPostTestName(updatedPostTestList?.find(x=>x.id == persistPostTestId)?.name);
              break;
            default:
            {
              setPreTestList(updatedPreTestList);
              let preTest = updatedPreTestList?.find(x=>x.id == persistPreTestId);
              setPersistData((prevCriteria) => ({
                ...prevCriteria,
                preTestID: preTest?.id ?? -1,
              }));
              setSelectedPreTestName(preTest ? preTest.name : 'Select Pre Test');

              setMidTestList(updatedMidTestList);
              let midTest = updatedMidTestList?.find(x=>x.id == persistMidTestId);
              setPersistData((prevCriteria) => ({
                ...prevCriteria,
                midTestID: midTest?.id ?? -1,
              }));
              setSelectedMidTestName(midTest ? midTest.name : 'Select Mid Test');

              setPostTestList(updatedPostTestList);
              let postTest = updatedPostTestList?.find(x=>x.id == persistPostTestId);
              setPersistData((prevCriteria) => ({
                ...prevCriteria,
                postTestID: postTest?.id ?? -1,
              }));
              setSelectedPostTestName(postTest ? postTest.name : 'Select Post Test');
            }
            }
          }
          else {
            const noResults = [{ id: -2, name: 'No results found' }];
            switch(dropDownId)
            {
            case 'preTestList':
              setPreTestList(noResults);
              break;
            case 'midTestList':
              setMidTestList(noResults);
              break;
            case 'postTestList':
              setPostTestList(noResults);
              break;
            default:
            { 
              setPreTestList(noResults);
              setMidTestList(noResults);
              setPostTestList(noResults);
            }
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
      setAssignmentListLoading(false);
    }
  };

  const loadMoreData = async() => {
    if (hasMore) {
      const skipValue = skip + takeSize;
      await getAllAssignmentsAsync(skipValue, takeSize, hasMore, persistData.classID, persistData.studentID, persistData.courseID, selectedList);
      setSkip(skipValue);
    }
  };

  useEffect(() => {
    getAllAssignmentsAsync(0, takeSize, true, persistData.classID, persistData.studentID, persistData.courseID, selectedList);
    setSkip(0);
  }, [searchString, preAssignmentType, midAssignmentType, postAssignmentType]);

  const getAssignmentType = (selectedDropDown) => {
    switch(selectedDropDown)
    {
    case 'preTestList':
      return preAssignmentType != null ? preAssignmentType : AssignmentTypes.All;
    case 'midTestList':
      return midAssignmentType != null ? midAssignmentType : AssignmentTypes.All;
    case 'postTestList':
      return postAssignmentType != null ? postAssignmentType : AssignmentTypes.All;
    default:
      return AssignmentTypes.All;
    }
  };

  const validateReportFilters = (preTestId, midTestId, postTestId, isPercentage, isPoints) => {
    if ((preTestId == postTestId || preTestId == midTestId || midTestId == postTestId) && ((preTestId != -1 && postTestId != -1) || midTestId != -1))
      setDisplayText('The Pre, Mid and Post Tests must be different! Check your choices and try again.');
    else if (!isPercentage && !isPoints)
      setDisplayText('Either Percentage or Points checkbox must be selected.');
    else
      setDisplayText('');
  };

  const resetAssignmentLists = () => {
    setPersistData((prevCriteria) => ({...prevCriteria, preTestID: -1, midTestID: -1, postTestID: -1}));
    setSelectedPreTestName('Select Pre Test');
    setSelectedMidTestName('Select Mid Test');
    setSelectedPostTestName('Select Post Test');
    setPreTestList([{ id: -1, name: 'Select Pre Test' }]);
    setMidTestList([{ id: -1, name: 'Select Mid Test' }]);
    setPostTestList([{ id: -1, name: 'Select Post Test' }]);
  };

  const handleClassChange = (classId) => {
    setPersistData((prevCriteria) => ({
      ...prevCriteria,
      classID: classId,
      studentID: -1
    }));
    const selectedClass = classList.filter((item) => item.id == classId);
    if (selectedClass.length > 0)
      setSelectedClassName(selectedClass[0].name);

    resetAssignmentLists();
    setGrowthReport({});
    getAllStudentsAsync(classId, -1);
    getAllAssignmentsAsync(0, takeSize, true, classId, -1, persistData.courseID, '', true);
    setSkip(0);
  };

  const handleStudentChange = (studentId) => {
    setPersistData((prevCriteria) => ({
      ...prevCriteria,
      studentID: studentId
    }));
    const selectedStudent = studentList.filter((item) => item.id == studentId);
    if (selectedStudent.length > 0)
      setSelectedStudentName(selectedStudent[0].name);

    resetAssignmentLists();
    setGrowthReport({});
    getAllAssignmentsAsync(0, takeSize, true, persistData.classID, studentId, persistData.courseID, '', true);
    setSkip(0);
  };

  const handleCourseChange = (courseId) => {
    setPersistData((prevCriteria) => ({
      ...prevCriteria,
      courseID: courseId
    }));
    const selectedCourse = courseList.filter((item) => item.id == courseId);
    if (selectedCourse.length > 0)
      setSelectedCourseName(selectedCourse[0].name);

    resetAssignmentLists();
    setGrowthReport({});
    getAllAssignmentsAsync(0, takeSize, true, persistData.classID, persistData.studentID, courseId, '', true);
    setSkip(0);
  };

  const handlePreTestChange = (preTestId) => {
    setPersistData((prevCriteria) => ({
      ...prevCriteria,
      preTestID: preTestId
    }));
    const selectedPreTest = preTestList.filter((item) => item.id == preTestId);
    if (selectedPreTest.length > 0)
      setSelectedPreTestName(selectedPreTest[0].name);

    validateReportFilters(preTestId, persistData.midTestID, persistData.postTestID, persistData.percentage, persistData.points);
    setGrowthReport({});
  };

  const handleMidTestChange = (midTestId) => {
    setPersistData((prevCriteria) => ({
      ...prevCriteria,
      midTestID: midTestId
    }));
    const selectedMidTest = midTestList.filter((item) => item.id == midTestId);
    if (selectedMidTest.length > 0)
      setSelectedMidTestName(selectedMidTest[0].name);

    validateReportFilters(persistData.preTestID, midTestId, persistData.postTestID, persistData.percentage, persistData.points);
    setGrowthReport({});
  };

  const handlePostTestChange = (postTestId) => {
    setPersistData((prevCriteria) => ({
      ...prevCriteria,
      postTestID: postTestId
    }));
    const selectedPostTest = postTestList.filter((item) => item.id == postTestId);
    if (selectedPostTest.length > 0)
      setSelectedPostTestName(selectedPostTest[0].name);

    validateReportFilters(persistData.preTestID, persistData.midTestID, postTestId, persistData.percentage, persistData.points);
    setGrowthReport({});
  };
  
  return (
    <>
      <div id='reportFilter' className='pt-4'>
        {isLoading ?
          (
            <SkeletonGrid colCount={3} rowCount={3} className={'mt-5 p-2'}/>
          ):(
            <>
              <Row>
                <Col>
                  <label>District</label>
                  <input
                    className="form-control disable-Pointer-Events"
                    type='text'
                    value={districtName}
                    readOnly>
                  </input>
                </Col>
                <Col>
                  <label>Location</label>
                  <input
                    className="form-control disable-Pointer-Events"
                    type='text'
                    value={locationName}
                    readOnly>
                  </input>
                </Col>
                <Col>
                  <label>Teacher</label>
                  <input
                    className="form-control disable-Pointer-Events"
                    type='text'
                    value={`${user?.LastName} ${user?.FirstName}`}
                    readOnly>
                  </input>
                </Col>
              </Row>
              <Row className='mt-4'>
                <Col>
                  <label>Class</label>
                  <DropDownSelect
                    value={classList}
                    selectedId={persistData.classID}
                    onChange={(e) => handleClassChange(Number(e.key))}
                    dropdownId="classList"
                    selectedName={selectedClassName}
                  />
                </Col>
                <Col>
                  <label>Student</label>
                  <DropDownSelect
                    value={studentList}
                    selectedId={persistData.studentID}
                    onChange={(e) => handleStudentChange(Number(e.key))}
                    dropdownId="studentList"
                    selectedName={selectedStudentName}
                  />
                </Col>
                <Col>
                  <label>Course</label>
                  <DropDownSelect
                    value={courseList}
                    selectedId={persistData.courseID}
                    onChange={(e) => handleCourseChange(Number(e.key))}
                    dropdownId="courseList"
                    selectedName={selectedCourseName}
                  />
                </Col>
              </Row>
              <Row className='mt-4 pb-2'>
                <Col>
                  <label>Pre Test</label>
                  <DropDownTileSelect
                    value={preTestList}
                    selectedId={persistData.preTestID}
                    onChange={(e) => handlePreTestChange(Number(e.key))}
                    dropdownId="preTestList"
                    selectedName={selectedPreTestName}
                    groups={AssignmentFilterTypes}
                    loadMoreData={loadMoreData}
                    selectedGroup={preAssignmentType}
                    setSelectedGroup={setPreAssignmentType}
                    isLoading={assignmentListLoading}
                    setSearchString={setSearchString}
                    setSelectedDropDown={setSelectedDropDown}
                    className={persistData.preTestID == -1 ? 'border-castleRed' : ''}
                  />
                </Col>
                <Col>
                  <label>Mid Test</label>
                  <DropDownTileSelect
                    value={midTestList}
                    selectedId={persistData.midTestID}
                    onChange={(e) => handleMidTestChange(Number(e.key))}
                    dropdownId="midTestList"
                    selectedName={selectedMidTestName}
                    groups={AssignmentFilterTypes}
                    loadMoreData={loadMoreData}
                    selectedGroup={midAssignmentType}
                    setSelectedGroup={setMidAssignmentType}
                    isLoading={assignmentListLoading}
                    setSearchString={setSearchString}
                    setSelectedDropDown={setSelectedDropDown}
                  />
                </Col>
                <Col>
                  <label>Post Test</label>
                  <DropDownTileSelect
                    value={postTestList}
                    selectedId={persistData.postTestID}
                    onChange={(e) => handlePostTestChange(Number(e.key))}
                    dropdownId="postTestList"
                    selectedName={selectedPostTestName}
                    groups={AssignmentFilterTypes}
                    loadMoreData={loadMoreData}
                    selectedGroup={postAssignmentType}
                    setSelectedGroup={setPostAssignmentType}
                    isLoading={assignmentListLoading}
                    setSearchString={setSearchString}
                    setSelectedDropDown={setSelectedDropDown}
                    className={persistData.postTestID == -1 ? 'border-castleRed' : ''}
                  />
                </Col>
              </Row>
              {displayText.length > 0 &&
                <Row className='m-0 pt-2 text-danger'>{displayText}</Row>
              }
              <Col className="mt-4">
                <Col className='d-flex justify-content-between'>
                  <div id='reportCriteriaBtn' className='d-flex align-items-center align-self-end fw-500 text-castleOrange cursor-pointer'
                    onClick={() => setIsReportCriteriaOpen(!isReportCriteriaOpen)}>
                    <span>Report Criteria</span>
                    <FontAwesomeIcon className='fs-6 ms-2' icon={isReportCriteriaOpen ? faSquareMinus : faSquarePlus} />
                  </div>
                  <div className="margin-left-auto d-flex gap-3">
                    <button id="generate_button" onClick={() => handleGenerateReport()} className="btn btn-castleRed min-w-150" disabled={isLoadingReportData || persistData.preTestID == -1 || persistData.postTestID == -1 || displayText.length > 0 || assignmentListLoading}>
                      {isLoadingReportData ? 'Generating Report' : 'Generate Report'}
                    </button>
                  </div>
                </Col>
                <Col id='reportCriteria' key={dateTimeBasedUniqueKey} className={`mt-3 report-options ${!isReportCriteriaOpen && 'd-none'}`}>
                  <span className="mb-3 fw-500 fs-5 pb-2 d-flex">Report Criteria</span>
                  <Row>
                    <Col>
                      <input
                        type="checkbox"
                        className="form-check-input me-2 cursor-pointer border-secondary"
                        checked={persistData.topics}
                        id="displayTopicsCheck"
                        name="displayTopics"
                        onChange={() => {
                          setPersistData((prevCriteria) => ({
                            ...prevCriteria,
                            topics: !prevCriteria.topics
                          }));
                        }}
                      />
                      <label className="form-check-label">
                        Display Topics
                      </label>
                    </Col>
                    <Col>
                      <input
                        type="checkbox"
                        className="form-check-input me-2 cursor-pointer border-secondary"
                        checked={persistData.students}
                        id="displayStudentsCheck"
                        name="displayStudents"
                        onChange={() => {
                          setPersistData((prevCriteria) => ({
                            ...prevCriteria,
                            students: !prevCriteria.students
                          }));
                        }}
                      />
                      <label className="form-check-label">
                        Display Students
                      </label>
                    </Col>
                    <Col>
                      <input
                        type="checkbox"
                        className="form-check-input me-2 cursor-pointer border-secondary"
                        checked={persistData.percentage}
                        id="percentageCheck"
                        name="percentage"
                        onChange={() => {
                          setPersistData((prevCriteria) => ({
                            ...prevCriteria,
                            percentage: !prevCriteria.percentage
                          }));
                          validateReportFilters(persistData.preTestID, persistData.midTestID, persistData.postTestID, !persistData.percentage, persistData.points);
                        }}             
                      />
                      <label className="form-check-label">
                        Percentage
                      </label>
                    </Col>  
                  </Row>
                  <Row>
                    <Col>
                      <input
                        type="checkbox"
                        className="form-check-input me-2 cursor-pointer border-secondary"
                        checked={persistData.standards}
                        id="displayStandardsCheck"
                        name="displayStandards"
                        onChange={() => {
                          setPersistData((prevCriteria) => ({
                            ...prevCriteria,
                            standards: !prevCriteria.standards
                          }));
                        }}             
                      />
                      <label className="form-check-label">
                        Display Standards
                      </label>
                    </Col>
                    <Col>
                      <input
                        type="checkbox"
                        className="form-check-input me-2 cursor-pointer border-secondary"
                        checked={persistData.questions}
                        id="displayQuestionsCheck"
                        name="displayQuestions"
                        onChange={() => {
                          setPersistData((prevCriteria) => ({
                            ...prevCriteria,
                            questions: !prevCriteria.questions
                          }));
                        }}
                      />
                      <label className="form-check-label">
                        Display Questions
                      </label>
                      <OverlayTrigger
                        key={'question-tooltip'}
                        placement="top"
                        overlay={
                          <Tooltip className="additional-options-tooltip">
                            <p>
                                For the most accurate data please ensure you have the same questions on all assignments,
                                in the same position, if choosing this option.
                            </p>
                          </Tooltip>
                        }>
                        <FontAwesomeIcon id='infoIcon' className="circle-question mx-1" icon={faCircleQuestion} />
                      </OverlayTrigger>
                    </Col>
                    <Col>
                      <input
                        type="checkbox"
                        className="form-check-input me-2 cursor-pointer border-secondary"
                        checked={persistData.points}
                        id="pointsCheck"
                        name="points"
                        onChange={() => {
                          setPersistData((prevCriteria) => ({
                            ...prevCriteria,
                            points: !prevCriteria.points
                          }));
                          validateReportFilters(persistData.preTestID, persistData.midTestID, persistData.postTestID, persistData.percentage, !persistData.points);
                        }}
                      />
                      <label className="form-check-label">
                        Points
                      </label>
                    </Col>
                  </Row>
                  <Row>
                    <Col className='col-4'>
                      <input
                        type="checkbox"
                        className="form-check-input me-2 cursor-pointer border-secondary"
                        checked={persistData.bloom}
                        id="displayBloomWebbCheck"
                        name="displayBloomWebb"
                        onChange={() => {
                          setPersistData((prevCriteria) => ({
                            ...prevCriteria,
                            bloom: !prevCriteria.bloom
                          }));
                        }}
                      />
                      <label className="form-check-label">
                        Display Bloom and Webb
                      </label>
                    </Col>
                    <Col>
                      <input
                        type="checkbox"
                        className="form-check-input me-2 cursor-pointer border-secondary"
                        checked={persistData.growth}
                        id="displayGrowthBtwTestsCheck"
                        name="displayGrowthBtwTests"
                        onChange={() => {
                          setPersistData((prevCriteria) => ({
                            ...prevCriteria,
                            growth: !prevCriteria.growth
                          }));
                        }}
                      />
                      <label className="form-check-label">
                        Display Growth Between Tests
                      </label>
                    </Col>
                  </Row>
                  <Row className='mt-4 pb-3'>
                    <Col className='col-4'>
                      <Col className='d-flex justify-content-between'>
                        <label className='align-items-center d-flex'>{'Growth Threshold (Percent)'}</label>
                        <input
                          type="text"
                          value={persistData.thresholdPercent}
                          className="form-control w-15 text-lg-center text-secondary"
                          id="growthPercentage"
                          disabled={true}
                        />
                      </Col>
                      <Col className="sliding-bar pt-2">
                        <Slider
                          min={1}
                          max={100}
                          value={persistData.thresholdPercent}
                          onChange={(e) => setPersistData((prevCriteria) => ({
                            ...prevCriteria,
                            thresholdPercent: Number(e),
                          }))}
                          marks={{ 1: 1, 100: 100 }}
                        />
                      </Col>
                    </Col>
                    <Col className='col-4'>
                      <Col className='d-flex justify-content-between'>
                        <label className='align-items-center d-flex'>{'Growth Threshold (Points)'}</label>
                        <input
                          type="text"
                          value={persistData.thresholdPoints}
                          className="form-control w-15 text-lg-center text-secondary"
                          id="growthPoints"
                          disabled={true}
                        />
                      </Col>
                      <Col className="sliding-bar pt-2">
                        <Slider
                          min={1}
                          max={100}
                          value={persistData.thresholdPoints}
                          onChange={(e) => setPersistData((prevCriteria) => ({
                            ...prevCriteria,
                            thresholdPoints: Number(e)
                          }))}
                          marks={{ 1: 1, 100: 100 }}
                        />
                      </Col>
                    </Col>
                  </Row>
                </Col>
                <Row className='mt-4'>
                  <Col className='info-text d-flex align-items-center'>
                    <span id='infoIcon'>
                      <FontAwesomeIcon icon={faInfo} />
                    </span>
                    <label className='align-items-center d-flex fw-normal text-black-50'>Note that only sections that contain any data are displayed.</label>
                  </Col>
                </Row>
              </Col>
            </>
          )
        }
      </div>
    </>
  );
};

ReportFilter.propTypes = {
  dateTimeBasedUniqueKey: PropTypes.string,
  isLoadingReportData: PropTypes.bool,
  setIsLoadingReportData: PropTypes.func,
  persistData: PropTypes.object,
  setPersistData: PropTypes.func,
  setGrowthReport: PropTypes.func,
  setDisplayText: PropTypes.func,
  displayText: PropTypes.string,
  setDistrictName: PropTypes.func,
  districtName: PropTypes.string,
  setLocationName: PropTypes.func,
  locationName: PropTypes.string,
  setSelectedClassName: PropTypes.func,
  selectedClassName: PropTypes.string,
  setSelectedStudentName: PropTypes.func,
  selectedStudentName: PropTypes.string,
  setSelectedCourseName: PropTypes.func,
  selectedCourseName: PropTypes.string,
  setSelectedPreTestName: PropTypes.func,
  selectedPreTestName: PropTypes.string,
  setSelectedMidTestName: PropTypes.func,
  selectedMidTestName: PropTypes.string,
  setSelectedPostTestName: PropTypes.func,
  selectedPostTestName: PropTypes.string
};

export default ReportFilter;
